import { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import DashCard from "../../containers/dashcard";
import Othernav from "../../components/navs/othernav";
// import UpgradePlanModal from "../../components/modals/plans";
import { useUserContext } from "../../context/userContext";
import withAuth from "../../components/user/withAuth";
import { PushNotificationToggle } from "../../components/PushNotificationManager";

// Icons
import edit from "../../assets/edit-2.svg";
import rightarr from "../../assets/rightarr.svg";
import lockcircle from "../../assets/lock-circle.svg";
import arrowswaphorizontal from "../../assets/arrow-swap-horizontal.svg";
import faq from "../../assets/faq.svg";
import support from "../../assets/24-support.svg";
import logout from "../../assets/logout.svg";

const Profile = () => {
  const navigate = useNavigate();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const { user } = useUserContext();
  const [stableUser, setStableUser] = useState(null);

  // ✅ Keep last valid user stable
  useEffect(() => {
    if (user?.user) {
      setStableUser(user.user);
    }
  }, [user]);

  // ✅ Memoize logout to prevent re-creation on every render
  const handleLogout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/auth/signin");
  }, [navigate]);

  // ✅ Stable settings (no more missing menu item)
  const settings = useMemo(
    () => [
      {
        icon: lockcircle,
        label: "Password Settings",
        path: "/account/password-update",
      },
      {
        icon: arrowswaphorizontal,
        label: "Current Plan",
        action: () => {},
      },
      {
        icon: faq,
        label: "Withdrawal Account",
        action: () => {},
      },
      {
        icon: faq,
        label: "FAQ",
        path: "/account/faq",
      },
      {
        icon: support,
        label: "Support",
        action: () => (window.location.href = "https://wa.link/3sw2da"),
      },
      {
        icon: faq,
        label: "Terms Of Use",
        action: () =>
          (window.location.href = "https://www.tweezers.app/policies"),
      },
      {
        icon: logout,
        label: "Log out",
        action: handleLogout,
        className: "text-red-600",
      },
    ],
    [handleLogout]
  );

  if (!stableUser) return null;

  const avatarUrl = `https://api.dicebear.com/7.x/identicon/svg?seed=${stableUser.name}`;

  return (
    <div>
      <Othernav headerDetails="My Profile" navLink="/account/home" />

      <DashCard className="max-w-3xl mx-auto p-4 md:mt-40">
        {/* Profile Header */}
        <div className="bg-white shadow-sm rounded-xl p-3 m-2 py-3 flex justify-between items-center mt-4 relative bottom-32 md:bottom-44">
          <div className="flex items-center gap-3">
            <img
              src={avatarUrl}
              alt="User Avatar"
              className="rounded-full w-8 h-8 border border-amber-50 bg-amber-100"
            />
            <div>
              <h2 className="font-semibold text-sm md:text-lg">
                {stableUser.name}
              </h2>
            </div>
          </div>

          <button
            onClick={() => navigate("/account/profile-edit")}
            className="bg-secondary text-white px-4 py-1.5 rounded-lg flex items-center gap-1 text-xs md:text-sm"
          >
            Edit
            <span className="text-green-400">
              <img src={edit} alt="Edit" className="w-4 h-4" />
            </span>
          </button>
        </div>

        {/* Push Notification Toggle */}
        <div className="mb-4 relative bottom-32">
          <PushNotificationToggle />
        </div>

        {/* Settings List */}
        <div className="divide-y divide-gray-100 shadow-sm md:shadow-none rounded-2xl md:rounded-none relative bottom-32">
          {settings.map((item, index) => (
            <div
              key={index}
              className="block cursor-pointer"
              onClick={item.action || (() => navigate(item.path))}
            >
              <div className="flex items-center justify-between p-4 hover:bg-gray-100">
                <div
                  className={`flex items-center gap-3 ${item.className || ""}`}
                >
                  <img src={item.icon} alt={item.label} className="w-5 h-5" />
                  <span>{item.label}</span>
                </div>
                <img src={rightarr} alt="Arrow" className="w-3 h-3" />
              </div>
            </div>
          ))}
        </div>
      </DashCard>
      {/* Payment/Subscription modal disabled */}
      {/* <UpgradePlanModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      /> */}
    </div>
  );
};

const AuthenticatedProfile = withAuth(Profile);
export default AuthenticatedProfile;
